import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import {
  AUTH_CHANGED_EVENT,
  PROFILE_UPDATED_EVENT,
  fetchMe,
  getCachedSessionUser,
  getStoredToken,
} from '../services/authService';

export default function AdminRoute({ children }) {
  const [state, setState] = useState(() => {
    const cached = getCachedSessionUser();
    return {
      loading: !!getStoredToken() && !cached?.role,
      isAdmin: cached?.role === 'ADMIN',
    };
  });

  useEffect(() => {
    let cancelled = false;

    const sync = () => {
      if (!getStoredToken()) {
        setState({ loading: false, isAdmin: false });
        return;
      }
      const cached = getCachedSessionUser();
      if (cached?.role) {
        setState({ loading: false, isAdmin: cached.role === 'ADMIN' });
      }
      fetchMe()
        .then((me) => {
          if (!cancelled) {
            setState({ loading: false, isAdmin: me?.role === 'ADMIN' });
          }
        })
        .catch(() => {
          if (!cancelled) {
            setState({
              loading: false,
              isAdmin: getCachedSessionUser()?.role === 'ADMIN',
            });
          }
        });
    };

    sync();
    window.addEventListener(AUTH_CHANGED_EVENT, sync);
    window.addEventListener(PROFILE_UPDATED_EVENT, sync);
    return () => {
      cancelled = true;
      window.removeEventListener(AUTH_CHANGED_EVENT, sync);
      window.removeEventListener(PROFILE_UPDATED_EVENT, sync);
    };
  }, []);

  if (state.loading) {
    return (
      <div className="admin-route-loading" style={{ padding: '2rem', color: '#6b7280' }}>
        Loading…
      </div>
    );
  }

  if (!state.isAdmin) {
    return <Navigate to="/resume" replace />;
  }

  return children;
}
